import { Box } from "@mui/material"
import { useCurrentSong } from "../../hooks/contexts/currentSongContext"
import { Image } from "./Image/Image"
import logo from "../f_500x500_white_bg.png"
import Text from "./Text"
import { SONG_TYPES } from "../../utils/types"
import { formatString } from "../../utils/formatter"

const NowPlaying = () => {
  const currentSong = useCurrentSong()
  const isKeytone = currentSong?.type === SONG_TYPES.KEY
  if (!currentSong) return null

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ height: 'clamp(80px, 18vh, 180px)', overflow: 'hidden', borderRadius: 1 }}>
        <Image
          src={currentSong.img || logo}
          description={currentSong.title}
          sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </Box>
      <Box sx={{ py: 'clamp(8px, 1.2vh, 16px)' }}>
        <Text
          bold
          displayedLines={1}
          overflow="hidden"
        >
          {isKeytone ? `${currentSong.keytone} ${formatString(currentSong.category)}` : currentSong.title}
        </Text>
      </Box>
    </Box>
  )
}

export default NowPlaying
